(function () {
  document.querySelectorAll('.tm-testimonials').forEach(function (section) {
    var slides = section.querySelectorAll('.tm-testi-slide');
    var dots = section.querySelectorAll('[data-testi-dot]');
    var prev = section.querySelector('[data-testi-prev]');
    var next = section.querySelector('[data-testi-next]');
    if (slides.length < 2) return;
    var i = 0, timer;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, 7000);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.dataset.testiDot, 10));
        restart();
      });
    });
    if (prev) prev.addEventListener('click', function () { show(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(i + 1); restart(); });

    show(0);
    restart();
  });
})();
